import { connect } from 'react-redux';

import { actions } from 'Data/actions';
import PostMeeting from './component';

export default connect(null, (dispatch) => ({
  openMeetingFeedbackModal: () => dispatch(actions.modalOpen({
    id: 'meetingFeedback',
  })),
}))(PostMeeting);
